<template>
  <ChartCard :title="'Stage Distribution Across ' + teamCount + ' Teams'" infoText="Goal: Stage 3 & 4" chartHeight="300px">
    <Bar :data="barData" :options="barOptions" />
  </ChartCard>
</template>

<script>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

import ChartCard from './ChartCard.vue'

export default {
  name: 'StageDistributionChart',
  components: { Bar, ChartCard },
  props: {
    teamData: { type: Array, default: () => [[0, 17, 41], [25, 50, 42], [42, 25, 17], [25, 8, 0]] },
    teamCount: { type: Number, default: 12 },
    rounds: { type: Number, default: 3 },
    chartMax: { type: Number, default: 12 }
  },
  computed: {
    barData() {
      const actualRounds = this.teamData && this.teamData[0] ? this.teamData[0].length : 0
      return {
        labels: Array.from({ length: actualRounds }, (_, i) => String(i + 1)),
        datasets: [
          { label: 'Stage 4 — Work & Productivity', data: this.teamData[0] || [], backgroundColor: '#0e8e9c', borderRadius: 0 },
          { label: 'Stage 3 — Trust & Structure', data: this.teamData[1] || [], backgroundColor: '#0a5c67', borderRadius: 0 },
          { label: 'Stage 2 — Counterdependency & Fight', data: this.teamData[2] || [], backgroundColor: '#c76b88', borderRadius: 0 },
          { label: 'Stage 1 — Dependency & Inclusion', data: this.teamData[3] || [], backgroundColor: '#9fb4d6', borderRadius: 0 },
          { label: 'No Stage', data: this.teamData[4] || [], backgroundColor: '#d1d5db', borderRadius: 0 }
        ]
      }
    },
    barOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'bottom', align: 'start', labels: { usePointStyle: true, boxWidth: 10, font: { size: 11 } } },
          tooltip: { callbacks: { label: (ctx) => `${ctx.dataset.label}: ${ctx.raw}` } }
        },
        scales: {
          x: { stacked: true, grid: { display: false }, title: { display: false } },
          y: { stacked: true, min: 0, max: this.chartMax, ticks: { stepSize: 1, callback: (v) => Math.round(v) }, grid: { color: '#f0f0f0' } }
        }
      }
    }
  }
}
</script>
